const placementData = {
    why1: "MEC has always maintained impressive records in placements and has been host to the biggest names in the industry when it comes to recruitment drives. Our placement records show that the students of MEC go the extra mile in technical and personality aspects. We were featured 37th among the top 100 engineering colleges in India by Outlook magazine and 35th among the top 100 T-Schools of India by DataQuest respectively for the year 2017.",
    why2: "Our students do summer internships at prestigious organizations such as Oracle, Siemens, Ansys, S&P Capital IQ, and Deloitte to get exposure to the corporate world that awaits them. We have showcased record-breaking placement status year after year, with students being placed with stellar packages at tech tycoons and global giants including Google, Amazon, Twitter, Microsoft, Oracle, Deloitte, Infosys, and TCS.",
    activities: [
        {
            id: 1,
            act: "Sessions of grueling tests, mock interviews, coding challenges, and group discussions are conducted."
        },
        {
            id: 2,
            act: "Technical talks and workshops led by industry experts of reputed companies are conducted with a view of expansion of technical knowledge."
        },
        {
            id: 3,
            act: "Soft skill development programs required for the corporates are also part of our curriculum."
        },
        {
            id: 4,
            act: "XMECians hold regular talks on the current industry trends and job opportunities in India and abroad."
        },
        {
            id: 5,
            act: "Faculty from Management Training Institutes hold regular classes on personality development."
        },
        {
            id: 6,
            act: "Actively conducts talks by eminent personalities from different walks of life, on career guidance, the importance of communication skills, and on other related stuff."
        },
    ]
}


export default placementData